export const PublicLayout = ({ children }) => (
  <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex flex-col">
    {/* Header officiel avec logos */}
    <header className="bg-[#1B4D3E] text-white">
      <div className="max-w-6xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo METPS à gauche */}
          <div className="flex items-center gap-3">
            <img 
              src="/logo_metps.jpg" 
              alt="Ministère de l'Emploi, du Travail et de la Protection Sociale" 
              className="h-14 w-14 object-contain bg-white rounded-full p-1"
            />
            <div className="hidden md:block">
              <h1 className="text-base font-bold leading-tight">MINISTÈRE DE L'EMPLOI</h1>
              <p className="text-emerald-200 text-xs">DU TRAVAIL ET DE LA PROTECTION SOCIALE</p>
              <p className="text-emerald-300 text-xs font-medium">Inspection Générale du Travail</p>
            </div>
          </div>
          
          {/* Titre central */}
          <div className="text-center flex-1 px-2">
            <h2 className="text-xs sm:text-sm font-semibold text-emerald-100">
              Plateforme de Déclaration du Bilan Social
            </h2>
          </div>
          
          {/* Logos à droite : Simandou + Guinée */}
          <div className="flex items-center gap-3">
            {/* Logo Simandou */}
            <img 
              src="/logo_simandou.jpeg" 
              alt="Programme Simandou 2040" 
              className="h-12 w-auto object-contain bg-white rounded p-1 hidden sm:block"
            />
            
            {/* Logo Guinée */}
            <div className="flex items-center gap-2">
              <div className="hidden lg:block text-right">
                <p className="text-xs text-emerald-200">République de</p>
                <p className="text-sm font-bold text-white">GUINÉE</p>
              </div>
              <img 
                src="/logo_guinee.png" 
                alt="République de Guinée" 
                className="h-12 w-12 object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </header>

    <main className="max-w-4xl w-full mx-auto px-4 py-8 flex-1">{children}</main>

    {/* Footer avec logos */}
    <footer className="bg-slate-800 text-white py-6">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Logo METPS */}
          <div className="flex items-center gap-3">
            <img src="/logo_metps.jpg" alt="METPS" className="h-10 w-10 rounded-full bg-white p-0.5" />
            <div className="text-left">
              <p className="text-xs text-slate-400">Ministère de l'Emploi, du Travail</p>
              <p className="text-xs text-slate-500">et de la Protection Sociale</p>
            </div>
          </div>
          
          {/* Centre : Logo Simandou + Copyright */}
          <div className="flex flex-col items-center gap-2">
            <img src="/logo_simandou.jpeg" alt="Simandou 2040" className="h-8 w-auto object-contain bg-white rounded px-2 py-1" />
            <p className="text-sm text-slate-400">
              © {new Date().getFullYear()} Inspection Générale du Travail
            </p>
            <p className="text-xs text-slate-500">
              Plateforme de Déclaration et Certification du Bilan Social
            </p>
          </div>
          
          {/* Logo Guinée */}
          <div className="flex items-center gap-3">
            <div className="text-right">
              <p className="text-xs text-slate-400">République de</p>
              <p className="text-sm font-semibold text-slate-300">Guinée</p>
            </div>
            <img src="/logo_guinee.png" alt="Guinée" className="h-10 w-10 object-contain" />
          </div>
        </div>
        
        {/* Powered by ALO.sa */}
        <div className="text-center mt-4 pt-4 border-t border-slate-700">
          <a 
            href="https://www.okcgn.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-xs text-slate-400 hover:text-emerald-400 transition-colors"
          >
            Powered by <span className="font-semibold text-emerald-400">ALO.sa</span>
          </a>
        </div>
      </div>
    </footer>
  </div>
);
